export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["PLG"] = "plg";
    SubscriptionType["VaricentAdvantageAnalytics"] = "varicentAdvantageAnalytics";
    SubscriptionType["VaricentELT"] = "varicentELT";
    SubscriptionType["VaricentAI"] = "varicentAI";
    SubscriptionType["VaricentSalesPlanning"] = "varicentSalesPlanning";
    SubscriptionType["VaricentDesigner"] = "varicentDesigner";
})(SubscriptionType || (SubscriptionType = {}));
//# sourceMappingURL=subscriptionType.js.map